import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    wrapDialog: {
        width: 250, 
        height: 100, 
        padding: 20, 
        display: 'flex', 
        flexDirection: 'column'
    },
    titleDialog: {
        textAlign: 'center'
    },
    errorTitleDialog: {
        fontWeight: 700,
        color: 'red',
    },
    dialogButton: {
        color: 'rgb(36, 38, 62)',
        background: 'rgb(255, 206, 1)',
        border: '1px solid rgb(255, 206, 1)',
        padding: '5px 10px',
        borderRadius: '16px',
        maxHeight: '48px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        textTransform: 'uppercase',
        fontSize: 14,
        fontFamily: "PT Sans, sans-serif",
        userSelect: 'none',
        cursor: 'pointer',
        fontWeight: 700,
        textAlign: 'center'
    }
}))

export {
    useStyles
}